



















































































































import axios from "axios"
import {Component, Prop, Vue} from 'vue-property-decorator';
import {counter} from "@fortawesome/fontawesome-svg-core";


@Component({
    components: {}
})
export default class DepartmentBox extends Vue {

    DepartmentValues: any = [];
    uniqueArrDep: any = [];
    uniqueDepartments: any = [];
    list: any = [];
    department: any = null;

    jobCount: any = 0;


    async mounted() {


        await this.listDepartmentValues()
        this.uniqueArrDep = [...new Set(this.DepartmentValues.map((data: any) => data.categories.department))]

        this.uniqueArrDep.map((x: any) => {
            this.jobCount = 0
            this.DepartmentValues.map((y: any) => {
                if (y.categories.department === x){
                    this.jobCount++
                }
            })

            this.uniqueDepartments.push({ department:x,jobCount:this.jobCount})
        })
        console.log(this.uniqueDepartments);
    }


    async listDepartmentValues() {
        await axios.get(`https://api.lever.co/v0/postings/rackspace`)
            .then(((jobRes) => {
                this.DepartmentValues = jobRes.data;
            }))

    }



}

